// removed by extract-text-webpack-plugin
module.exports = {"root":"GeySM","label":"_2g_QW","value":"_3TIJT"};